<script>
export default {
  name: 'RouteView',
  props: {
    cache: {
      type: Boolean,
      default: true
    }
  },
  render() {
    return <router-view />;
  }
};
</script>
